import { render, staticRenderFns } from "./SMSCampaignListCreateOrEditMessage.vue?vue&type=template&id=920f4100&scoped=true&"
import script from "./SMSCampaignListCreateOrEditMessage.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignListCreateOrEditMessage.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignListCreateOrEditMessage.vue?vue&type=style&index=0&id=920f4100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920f4100",
  null
  
)

export default component.exports